import axios from '@/axios.js'
let entityURL = 'products'; // variant depending on entity URLs
let token = localStorage.getItem('accessToken');
let apiEndpoint = localStorage.getItem('apiEndpoint');
axios.defaults.baseURL = apiEndpoint;
axios.defaults.headers.common = { 'Authorization': `bearer ${token}` }

const state = {
    products: [],
    products_urls: [],
    product: {
        link: [],
        image: {}
    },
    // For product view
    pageCaption: ''
}

const getters = {
    getProducts: (state) => (state.products),
    getProductsUrls: (state) => (state.products_urls),
    getProduct: (state) => (state.product),
    getProductPageCaption: (state) => (state.pageCaption),
}

const actions = {
    // Add new product
    async addProduct({ commit }, payload) {
        const response = await axios.post(`${entityURL}/add`, payload)
        return response.data
    },

    // Fetch products
    async fetchProducts({ commit }) {
        console.log(`${entityURL}/list/1`)
        const response = await axios(`${entityURL}/list/1`)
        commit('SET_PRODUCTS', response.data)
    },

    async fetchProductsUrls({ commit }) {
        const response = await axios(`${entityURL}/list_urls`)
        commit('SET_PRODUCTS_URLS', response.data)
    },

    async fetchProductsUrlsStatus({ commit }, payload) {
        const response = await axios(`${entityURL}/list_urls_enabled/${payload}`)
        commit('SET_PRODUCTS_URLS', response.data)
    },

    async fetchProductsUrlsFailed({ commit }) {
        const response = await axios(`${entityURL}/list_urls_failed`)
        commit('SET_PRODUCTS_URLS', response.data)
    },

    // Fetch products by category id
    async fetchProductsByCategoryId({ commit }, payloadId) {
        const response = await axios(`${entityURL}/listByCategoryId/${payloadId}`)
        commit('SET_PRODUCTS', response.data)
    },

    // Fetch product
    async fetchProduct({ commit }, payloadId) {
        const response = await axios(`${entityURL}/get/${payloadId}`)
        commit('SET_PRODUCT', response.data)
    },

    // Update product
    async updateProduct({ commit }, payload) {
        const response = await axios.put(`${entityURL}/update/${payload.id}`, payload)
        return response.data
    },

    // Delete product
    async deleteProduct({ commit }, payloadId) {
        const response = await axios.delete(`${entityURL}/delete/${payloadId}`)
        return response.data.message
            // if (response.data.message === 'Successfully Deleted') {
            //     commit('DELETE_PRODUCT', payloadId)
            // }
    },

    async deleteProductFailing({ commit }, payloadId) {
        const response = await axios.delete(`${entityURL}/delete-failing/${payloadId}`)
        return response.data.message
        // if (response.data.message === 'Successfully Deleted') {
        //     commit('DELETE_PRODUCT', payloadId)
        // }
    },

    // Update xml
    async xmlUpdate({ commit }) {
        const response = await axios(`${entityURL}/xml-update`)
        return response.data
    },

    setProductPageCation({ commit }, value) {
        commit('SET_PRODUCT_PAGE_CAPTION', value)
    },

    setProduct({ commit }, payload) {
        commit('SET_PRODUCT', payload)
    },

    // Setter for part_number
    setProductPartNumber({ commit }, value) {
        commit('SET_PRODUCT_PART_NUMBER', value)
    },
    // Setter for checked
    setProductChecked({ commit }, value) {
        commit('SET_PRODUCT_CHECKED', value)
    },
    // Setter for name
    setProductName({ commit }, value) {
        commit('SET_PRODUCT_NAME', value)
    },
    // Setter for manufacturer
    setProductManufacturer({ commit }, value) {
        commit('SET_PRODUCT_MANUFACTURER', value)
    },
    setProductGroup({ commit }, value) {
        commit('SET_PRODUCT_GROUP', value)
    },
    setProductDescription({ commit }, value) {
        commit('SET_PRODUCT_DESCRIPTION', value)
    },
    // Setter for erp_price
    setProductErpPrice({ commit }, value) {
        commit('SET_PRODUCT_ERP_PRICE', value)
    },
    setProductSafePrice({ commit }, value) {
        commit('SET_PRODUCT_SAFE_PRICE', value)
    },
    // Setter for promo_price
    setProductPromoPrice({ commit }, value) {
        commit('SET_PRODUCT_PROMO_PRICE', value)
    },
    setProductCostPrice({ commit }, value) {
        commit('SET_PRODUCT_COST_PRICE', value)
    },
    // Setter for categoryId
    setProductCategoryId({ commit }, value) {
        commit('SET_PRODUCT_CATEGORY_ID', value)
    },

    setProductLink({ commit }, payload) {
        commit('SET_PRODUCT_LINK', payload)
    },

    // Setter for barcode
    setProductBarcode({ commit }, payload) {
        commit('SET_PRODUCT_BARCODE', payload)
    },

    // Setter for stock
    setProductStock({ commit }, payload) {
        commit('SET_PRODUCT_STOCK', payload)
    },

    // Setter for remoteId
    setProductRemoteId({ commit }, payload) {
        commit('SET_PRODUCT_REMOTE_ID', payload)
    },

    // Setter for has_stock
    setProductHasStock({ commit }, payload) {
        commit('SET_PRODUCT_HAS_STOCK', payload)
    },

    // Setter for image
    setProductImage({ commit }, payload) {
        commit('SET_PRODUCT_IMAGE', payload)
    },

    // Setter for is_favourite
    setProductFavourite({ commit }, payload) {
        commit('SET_PRODUCT_IS_FAVOURITE', payload)
    }
}

const mutations = {
    ADD_PRODUCT: (state, data) => {
        console.log(typeof state.products)
        state.products.push(data)
    },
    SET_PRODUCTS: (state, data) => (state.products = data),
    SET_PRODUCTS_URLS: (state, data) => (state.products_urls = data),
    SET_PRODUCT: (state, data) => (state.product = data),
    UPDATE_PRODUCT: (state, data) => {
        const productIndex = state.products.findIndex(x => x.id === data.id)
        if (productIndex !== -1) {
            state.products.splice(productIndex, 1, data)
        }
    },
    DELETE_PRODUCT: (state, data) => {
        const productIndex = state.products.findIndex(x => x.id === data)
        if (productIndex !== -1) {
            state.products.splice(productIndex, 1)
            state.product = {}
        }
    },
    SET_PRODUCT_PAGE_CAPTION: (state, data) => (state.pageCaption = data),
    SET_PRODUCT_PART_NUMBER: (state, data) => (state.product.part_number = data),
    SET_PRODUCT_CHECKED: (state, data) => (state.product.checked = data),
    SET_PRODUCT_NAME: (state, data) => (state.product.name = data),
    SET_PRODUCT_MANUFACTURER: (state, data) => (state.product.manufacturer = data),
    SET_PRODUCT_GROUP: (state, data) => (state.product.group = data),
    SET_PRODUCT_DESCRIPTION: (state, data) => (state.product.description = data),
    SET_PRODUCT_ERP_PRICE: (state, data) => (state.product.erp_price = data),
    SET_PRODUCT_SAFE_PRICE: (state, data) => (state.product.safe_price = data),
    SET_PRODUCT_PROMO_PRICE: (state, data) => (state.product.promo_price = data),
    SET_PRODUCT_COST_PRICE: (state, data) => (state.product.cost_price = data),
    SET_PRODUCT_CATEGORY_ID: (state, data) => (state.product.categoryId = data),
    SET_PRODUCT_LINK: (state, data) => {
        state.product.links = data
    },
    SET_PRODUCT_BARCODE: (state, data) => (state.product.barcode = data),
    SET_PRODUCT_STOCK: (state, data) => (state.product.stock = data),
    SET_PRODUCT_REMOTE_ID: (state, data) => (state.product.remoteId = data),
    SET_PRODUCT_HAS_STOCK: (state, data) => (state.product.has_stock = data),
    SET_PRODUCT_IMAGE: (state, data) => (state.product.image = data),
    SET_PRODUCT_IS_FAVOURITE: (state, data) => (state.product.is_favourite = data),
}


export default { state, getters, actions, mutations }
